export const numberFormats = {
  'it-IT': {
    currency: {
      style: 'currency',
      currency: 'EUR'
    }
  },
  'en-US': {
    currency: {
      style: 'currency',
      currency: 'USD'
    }
  },
  'en-UK': {
    currency: {
      style: 'currency',
      currency: 'GBP'
    }
  },
  'ch-CH': {
    currency: {
      style: 'currency',
      currency: 'CHF'
    }
  },
  'sv-SE': {
    currency: {
      style: 'currency',
      currency: 'SEK'
    }
  },
  'ja-JP': {
    currency: {
      style: 'currency',
      currency: 'JPY',
      currencyDisplay: 'symbol'
    }
  }
}

export const datetimeFormats: Record<string, Record<string, Intl.DateTimeFormatOptions>> = {
  'it-IT': {
    short: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric'
    }
  },
  'en-US': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    }
  }
}
